import { useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onEmployeeSelected: (employeeId: string[]) => void
  readonly?: boolean
}

const EmployeePreviewSelector = ({ onEmployeeSelected, readonly }: Props) => {
  const [selectedIds, setSelectedIds] = useState<string[]>([])

  return (
    <Box gap="s8">
      <EmployeeSelectorV2
        multiple={false}
        value={selectedIds[0]}
        disabled={readonly}
        onChange={(id) => {
          const ids = id != null ? [id] : []
          setSelectedIds(ids)
          onEmployeeSelected(ids)
        }}
        label={i18n.t('documents.document_templates.employee_preview.title')}
        messages={{
          placeholder: i18n.t('documents.document_templates.employee_preview.placeholder'),
        }}
      />
      <Text size="200" color="grey800">
        {i18n.t('documents.document_templates.employee_preview.description')}
      </Text>
    </Box>
  )
}

export default EmployeePreviewSelector
